// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/semantic.min.css
// module id = kVq8
// module chunks = 1